import { configService as config } from '../Config/config';
import { Theme } from '@ibe/components';

interface ThemeConfig {
  moduleLoader: () => Promise<{ default: Theme }>;
  icon: string;
}

const defaultTheme = 'legoland';

const themes: Map<string, ThemeConfig> = new Map([
  [
    defaultTheme,
    {
      moduleLoader: () => import('../Theme/Styles/Legoland/theme'),
      icon: 'favicon.ico'
    }
  ],
  [
    'gardaland',
    {
      moduleLoader: () => import('../Theme/Styles/Gardaland/theme'),
      icon: 'gardaland_favicon.ico'
    }
  ],
  [
    'heidepark',
    {
      moduleLoader: () => import('../Theme/Styles/Heidepark/theme'),
      icon: 'heidepark_favicon.png'
    }
  ],
  [
    'thorpe',
    {
      moduleLoader: () => import('../Theme/Styles/Thorpe/theme'),
      icon: 'thorpe_favicon.ico'
    }
  ],
  [
    'wac',
    {
      moduleLoader: () => import('../Theme/Styles/WarwickCastle/theme'),
      icon: 'warwick_favicon.ico'
    }
  ],
  [
    'alton',
    {
      moduleLoader: () => import('../Theme/Styles/AltonTowers/theme'),
      icon: 'alton_favicon.png'
    }
  ],
  [
    'chessington',
    {
      moduleLoader: () => import('../Theme/Styles/ChessingtonWorldOfAdventure/theme'),
      icon: 'chessington_favicon.ico'
    }
  ],
  [
    'billund',
    {
      moduleLoader: () => import('../Theme/Styles/Legoland/theme'),
      icon: 'billund_favicon.ico'
    }
  ]
]);

async function prepareTheme(props: ThemeConfig): Promise<Theme | {}> {
  const favicon = document.getElementById('favicon');
  if (favicon) {
    (favicon as HTMLLinkElement).href = `${document.location.origin}/${props.icon}`;
  }

  let theme: Theme | {} = {};

  await props.moduleLoader().then(themeModule => {
    theme = themeModule.default;
  });

  return theme;
}

export async function getTheme(): Promise<Theme | {}> {
  const themeName = config.get().theme ?? defaultTheme;
  const themeConfig = themes.get(themeName) ?? themes.get(defaultTheme);

  if (themeConfig) {
    return await prepareTheme(themeConfig);
  }

  return {};
}
